import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HashLink as LinkHash } from 'react-router-hash-link';
import { Container, Row, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import CardInfo from '../../components/cardInfo';
import { getRecentWinners } from '../../slices/recentWinnersSlice';
import LoaderCP from '../../components/loader';

const WinnerSection = () => {
  const dispatch = useDispatch();
  const { recentWinners, status } = useSelector((state) => state.recentWinners);

  useEffect(() => {
    dispatch(getRecentWinners());
  }, []);

  const renderCards = () => {
    return (

      <Container fluid className="bg-white py-60">
        <Container>
          <Row className="">
            <Col lg={12} className="text-center bg-white">
              <h2 className="text-tangaroa f-600">Ganadores recientes</h2>
            </Col>
          </Row>

          <Row>
            {recentWinners.filter((item, idx) => idx < 4).map((winner) => (
              <Col lg={3} sm={12} xs={12} className="br-5 d-block d-xs-block d-sm-block d-md-block d-lg-none d-xl-block" key={winner.auctionInfo.title}>
                <Link to={`/subastas/${winner.auctionInfo.urlName}/${winner.auctionInfo.id}`} className="btn-link">
                  <CardInfo
                    image={winner.auctionInfo.imageHome}
                    title={winner.auctionInfo.title}
                    winner={winner.personName}
                    type="winner" />
                </Link>
              </Col>
            ))}

            {recentWinners.filter((item, idx) => idx < 3).map((winner) => (
              <Col sm={4} className="br-5 d-none d-xs-none d-sm-none d-md-none d-lg-block d-xl-none" key={winner.auctionInfo.title}>
                <Link to={`/subastas/${winner.auctionInfo.urlName}/${winner.auctionInfo.id}`}>
                  <CardInfo
                    image={winner.auctionInfo.imageHome}
                    title={winner.auctionInfo.title}
                    winner={winner.personName}
                    type="winner" />
                </Link>
              </Col>
            ))}
          </Row>

          <Row>
            <Col lg={12} className="text-center mt-30">
              <LinkHash to="/ganadores/#up" className="btn btn-primary f-600" id="sbs-dsb-dgr-btn-sho">Ver todos los ganadores</LinkHash>
            </Col>
          </Row>
        </Container>
      </Container>
    );
  };

  return (
    <>
      {status === 'loading' ? <LoaderCP /> : ''}
      {status === 'failed' ? '' : ''}
      {status === 'success' && recentWinners.length > 0 ? renderCards() : ''}
    </>
  );
};

export default WinnerSection;
